export const ItemTypes = {
    CATEGORY: 'category',
    PL: 'pl',
    VIDEO: 'video',
    CARD: 'card',
  }
  